import { type SingleSelectedValueFilter } from 'components/brokers/types'

const EmployerOEMaxFinalRatesFilter = ({
  selectedValue,
  selectValue,
}: SingleSelectedValueFilter) => {
  return (
    <input
      type='number'
      placeholder='Max final rates %'
      value={selectedValue || ''}
      onChange={(e) => selectValue(e.target.value)}
      className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
      min={0}
      max={100}
    />
  )
}

export default EmployerOEMaxFinalRatesFilter
